import { render } from "./fldCheckbox.vue?vue&type=template&id=63574cd7"
import script from "./fldCheckbox.vue?vue&type=script&lang=js"
export * from "./fldCheckbox.vue?vue&type=script&lang=js"

import "./fldCheckbox.vue?vue&type=style&index=0&id=63574cd7&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection,QCheckbox,QItemLabel,QField});
